import axios from '@/plugins/axios'
import * as typesAPI from '@/models/api/models-api'
import { backendAPIConfig } from '@baseConfig'
import { StringHelper } from '@/helpers/string'
import { HttpStatus } from '@/models/converter/convert'
import { PostCardAlignmentSetupRequest } from '@/models/api/card-alignment-setup'

export class CardAlignmentSetupApi {
    /**
     * Web-LINE会員証取得
     * @public
     * @async
     * @param {PostCardAlignmentSetupRequest} request
     * @returns {typesAPI.APIResponse}
     */
    async postCardAlignmentSetup(request) {
        let res = {}
        if (request.mock) {
            res = {
                "data": {
                    "auth_key": "73NJ00000023"
                },
                "status": 200,
            }
        } else {
            res = await axios.post(`${backendAPIConfig.endpoint}/web/card/alignment/setup`, {
                provision_shop_code: request.provisionShopCode,
                card_number: request.cardNumber,
            })
        }
        return res
    }
}
